// WHAT: Shared types and context for reminders
// WHY:  Keep React components in .tsx file only for fast-refresh rule

import { createContext } from "react";

/**
 * Value interface for reminders context
 *
 * @public
 *
 */
// eslint-disable-next-line import/no-unused-modules -- Reason: This interface is exported for external use and type checking, even if not directly imported in other modules.
export interface RemindersContextValue {
  /** Number of due reminders */
  due: number;
}

export const RemindersContext = createContext<RemindersContextValue | undefined>(undefined);
